<template>
  <div class="modal fade" tabindex="-1" role="dialog">
    <div :class="`modal-${size}`" class="modal-dialog" role="document">
      <div class="modal-content mat">
        <capsim-loader
          v-show="isLoading"
          container-style="background-color: white; text-align: center;"
          :optionalFirstText="optionalFirstText"
          :optionalSecondText="optionalSecondText"
        ></capsim-loader>
        <div :class="['modal-header', context]">
          <button
            v-if="showExit"
            type="button"
            class="close"
            data-testid="modal-close-cy"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h3 class="modal-title mt-5 mb-5">
            <strong><slot name="title"></slot></strong>
          </h3>
        </div>
        <div class="modal-body">
          <slot name="body"></slot>
        </div>
        <div v-if="showFooter" class="modal-footer">
          <slot name="footer">
            <template v-if="showConfirmAsLink">
              <a
                v-if="showOkay"
                @click="$emit('confirm')"
                :class="`${confirmClass}`"
                :disabled="confirmDisabled"
              >
                {{ confirmText }}
              </a>
            </template>
            <template v-else>
              <button
                v-if="showOkay"
                @click="$emit('confirm')"
                type="button"
                data-testid="modal-confirm-cy"
                class="btn"
                :class="`${confirmClass}`"
                :disabled="confirmDisabled"
              >
                {{ confirmText }}
              </button>
            </template>

            <button
              v-if="showClose"
              @click="$emit('closed')"
              type="button"
              class="btn"
              :class="`${closeClass}`"
              :data-dismiss="dataDismiss"
              :disabled="closeDisabled"
            >
              {{ closeText }}
            </button>
          </slot>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>

<script>
  import CapsimLoader from './CapsimLoader.vue';
  export default {
    props: {
      size: {
        type: String,
        default: 'md',
      },
      className: {
        type: String,
        default: '',
      },
      confirmText: {
        type: String,
        default: 'Okay',
      },
      closeText: {
        type: String,
        default: 'Close',
      },
      confirmClass: {
        type: String,
        default: 'btn-success',
      },
      confirmDisabled: {
        type: Boolean,
        default: false,
      },
      closeDisabled: {
        type: Boolean,
        default: false,
      },
      closeClass: {
        type: String,
        default: 'btn-success',
      },
      showExit: {
        type: Boolean,
        default: true,
      },
      showClose: {
        type: Boolean,
        default: true,
      },
      showOkay: {
        type: Boolean,
        default: true,
      },
      showFooter: {
        type: Boolean,
        default: true,
      },
      showConfirmAsLink: {
        type: Boolean,
        default: false,
      },
      context: {
        type: String,
        default: function () {
          return '';
        },
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      optionalFirstText: {
        type: String,
        default: '',
      },
      optionalSecondText: {
        type: String,
        default: '',
      },
      closeModalUponClick: {
        type: Boolean,
        default: true,
      },
    },

    components: {
      CapsimLoader,
    },
    mounted() {
      // Leaving this for testing later
      // $(`#${this.$attrs.id}`).on('hidden.bs.modal', () => {
      //   this.$emit('closed');
      // });
    },
    computed: {
      dataDismiss() {
        return this.closeModalUponClick ? 'modal' : '';
      },
    },
  };
</script>

<style lang="scss">
  .modal-backdrop {
    display: none;
    position: relative;
    visibility: hidden;
  }

  .modal {
    background-color: rgba(0, 0, 0, 0.5);
  }
  .link {
    color: black;
    text-decoration: underline;
    cursor: pointer;
  }
</style>
